module.exports = __webpack_public_path__ + "img/jx1.bcfef3b9.png";